
import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        ongoing: "border-transparent bg-chapterly-purple text-white hover:bg-chapterly-purple/80",
        completed: "border-transparent bg-green-500 text-white hover:bg-green-500/80",
        hiatus: "border-transparent bg-amber-500 text-white hover:bg-amber-500/80",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  status?: "ongoing" | "completed" | "hiatus";
}

function Badge({ className, variant, status, ...props }: BadgeProps) {
  // If status is provided, use it as the variant
  const variantToUse = status || variant;
  
  return (
    <div className={cn(badgeVariants({ variant: variantToUse }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
